import React, { useState } from 'react';
import { connect } from 'react-redux';

import {
  sGetUnseenNotifications,
  sGetNotificationsFetching,
} from '../../../../store/reducers/notifications';

import { privateNavbarMenu } from '../../../../structure/menu';
import MobileNavbarBase from '../../../../components/MobileNavbar';
import MobileNavbarItem from '../../../../components/MobileNavbarItem';
import useDashboardLinkPrefix from '../../../../hooks/useDashboardLinkPrefix';
import { sGetPendingRequests } from '../../../../store/reducers/accessRequests';

const MobileNavbar = ({
  hidden,
  unseenNotifications,
  fetchingNotifications,
  pedningAccessRequests,
}) => {
  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const [activeIndex, setActiveIndex] = useState(0);
  const unseenNotificationsCount = unseenNotifications.length;

  const isActive = (index) => index === activeIndex;

  const getBadgeContent = (isNotification) =>
    isNotification && !fetchingNotifications ? unseenNotificationsCount : null;

  const navBarItems = privateNavbarMenu.filter(
    (item) => !item.desktopOnly && !item.isHide
  );

  return (
    <MobileNavbarBase showLabels hidden={hidden}>
      {navBarItems.map(
        (
          {
            link,
            title,
            icon,
            activeIcon,
            isNotification,
            iconProps,
            notificationLabel,
          },
          index
        ) => (
          <MobileNavbarItem
            icon={isActive(index) ? activeIcon : icon}
            title={title}
            iconProps={iconProps}
            isActive={isActive(index)}
            key={`bottom-nav-item-${link}`}
            to={`${dashboardLinkPrefix}/${link}`}
            onClick={() => setActiveIndex(index)}
            badgeContent={getBadgeContent(isNotification)}
            notificationCount={
              notificationLabel ? pedningAccessRequests.length : 0
            }
          />
        )
      )}
    </MobileNavbarBase>
  );
};

const mapStateToProps = (state) => ({
  unseenNotifications: sGetUnseenNotifications(state),
  fetchingNotifications: sGetNotificationsFetching(state),
  pedningAccessRequests: sGetPendingRequests(state),
});

export default connect(mapStateToProps, null)(MobileNavbar);
